import { render, staticRenderFns } from "./users.vue?vue&type=template&id=cfdf131a&scoped=true&"
import script from "./users.vue?vue&type=script&lang=js&"
export * from "./users.vue?vue&type=script&lang=js&"
import style0 from "./users.vue?vue&type=style&index=0&id=cfdf131a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdf131a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfdf131a')) {
      api.createRecord('cfdf131a', component.options)
    } else {
      api.reload('cfdf131a', component.options)
    }
    module.hot.accept("./users.vue?vue&type=template&id=cfdf131a&scoped=true&", function () {
      api.rerender('cfdf131a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/users/users.vue"
export default component.exports